import { render, staticRenderFns } from "./listminisite.vue?vue&type=template&id=059815f0&scoped=true"
import script from "./listminisite.vue?vue&type=script&lang=js"
export * from "./listminisite.vue?vue&type=script&lang=js"
import style0 from "./listminisite.vue?vue&type=style&index=0&id=059815f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059815f0",
  null
  
)

export default component.exports